import { Injectable } from '@angular/core';
import { Product } from '../models/product.model';
import { ApiService } from '../api.service';
import { isNull } from 'util';

@Injectable({
  providedIn: 'root'
})
export class HistoricoService {

  products: Product[];


  constructor(private apiService: ApiService) {

   }


  async productList(): Promise<Product[]>{
    if(this.products == null || this.products.length == 0)
    {
      this.products = await this.apiService.getArticulos('/api/historico');
    }
    return this.products;
  }
}
